import * as React from 'react';
import { Box, Link, Typography } from '@drone-js/core';
import { useAnalytics } from './analytics';

type ResendOtpWithTimerProps = {
    onClick: () => void;
    stepDuration?: number;
    translation: {
        didntReceive: string;
        resendCode: string;
    };
};

export const ResendOtpWithTimer: React.FC<ResendOtpWithTimerProps> = props => {
    const { onClick, stepDuration, translation } = props;
    const { AnalyticsResendOtpButtonProps } = useAnalytics();
    const [resendCount, setResendCount] = React.useState(0);
    const [linkDisabled, setLinkDisabled] = React.useState(true);
    const [timeRemaining, setTimeRemaining] = React.useState(0);

    const step = stepDuration ?? 1;

    React.useEffect(() => {
        if (timeRemaining === 0) {
            setLinkDisabled(false);
            return;
        }

        const timer = setTimeout(() => {
            if (timeRemaining > 0) {
                setTimeRemaining(timeRemaining => timeRemaining - step);
                return;
            }
        }, step * 1000);
        return () => clearTimeout(timer);
    }, [timeRemaining]);

    const onButtonClick = () => {
        onClick();
        setResendCount(resendCount + 1);
    };

    React.useEffect(() => {
        setTimeRemaining(30 + (resendCount || 0) * 60);
        setLinkDisabled(true);
    }, [resendCount]);

    return (
        <>
            <Box data-cy="wallet-resend-otp-text" display="flex" justifyContent="center" mt="16" alignItems="center">
                <Typography variant="body-s" textColor="base.subtle" me="4">
                    {translation.didntReceive}
                </Typography>
                <Link
                    data-cy="wallet-resend-otp-link"
                    {...AnalyticsResendOtpButtonProps}
                    onClick={onButtonClick}
                    disabled={linkDisabled}
                >
                    <Typography variant="body-s" textColor={linkDisabled ? 'base.subtle' : 'product.primary'}>
                        {translation.resendCode}
                    </Typography>
                </Link>
                {linkDisabled && <Typography ms="4" variant="body-s">{`(${timeRemaining})s`}</Typography>}
            </Box>
        </>
    );
};
